/**
 * Extracts meaningful error details from various error types, especially Supabase errors.
 * This helps provide better error messages in logs instead of empty objects.
 */
export const extractErrorDetails = (error: unknown): object => {
  if (error instanceof Error) {
    // Core error properties
    const coreProps = {
      name: error.name,
      message: error.message,
      stack: error.stack?.split('\n').slice(0, 3).join('\n') // First 3 lines of stack
    }

    // Known additional properties we want to prioritize
    const knownProps = {
      // Supabase-specific error properties
      ...((error as any).details && { details: (error as any).details }),
      ...((error as any).hint && { hint: (error as any).hint }),
      ...((error as any).code && { code: (error as any).code }),
      // HTTP error properties
      ...((error as any).status && { status: (error as any).status }),
      ...((error as any).statusText && { statusText: (error as any).statusText })
    }

    // Capture any other enumerable properties that might be useful
    const reservedKeys = ['name', 'message', 'stack', 'details', 'hint', 'code', 'status', 'statusText']
    const otherProps = Object.fromEntries(
      Object.entries(error).filter(([key]) => !reservedKeys.includes(key))
    )

    return {
      ...coreProps,
      ...knownProps,
      ...otherProps
    }
  }

  return { unknownError: error }
}
